import { ASSET_STORAGE_URL } from '~/modules/config';

/**
 * Takes a complete, or partial asset URL and generates a the final URL of the asset
 * by appending ASSET_STORAGE_URL to incomplete urls, aka OAF mediaIds (which are uuids).
 * If the URL is a complete URL (aka legacy URLs), this function simply returns them.
 *
 * @param mediaId A legacy URL, or UUID that will be appended to ASSET_STORAGE_URL to produce the final URL.
 * @returns URL of media asset.
 */
export function generateMediaUrl(mediaId: string) {
    if (!mediaId) {
        return '';
    }

    // If the mediaId already contains the ASSET_STORAGE_URL, return it as it is assumed to be a complete URL.
    if (mediaId.includes(ASSET_STORAGE_URL)) {
        return mediaId;
    }

    // If the mediaId includes a legacy media path '/servlet/servlet.FileDownload?file=',
    // return the mediaId as it is assumed to be a legacy media URL.
    const legacyMediaPath = '/servlet/servlet.FileDownload?file=';
    if (mediaId.includes(legacyMediaPath)) {
        return mediaId;
    }

    // If the mediaId does not contain ASSET_STORAGE_URL or the legacy media path,
    // concatenate the mediaId with ASSET_STORAGE_URL to form the complete media URL.
    return `${ASSET_STORAGE_URL}/${mediaId}`;
}
